import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';


@Injectable()
export class AuthGuard implements CanActivate {

  timeout = 10000;

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot) {

    if (state.url.search('/?laudo') < 0 && state.url.search('/videos') < 0 && state.url.search('/imagemoriginal') < 0 && state.url.search('/laudos')) {
      this.router.navigate(['/laudosms/']);
    }
    return true;
  }
}

